import React from "react";
import { PAIN_ITEMS } from "../marketingData";

const PainIcon = ({ type }) => {
  if (type === "card") {
    return (
      <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" />
        <line x1="1" y1="10" x2="23" y2="10" />
      </svg>
    );
  }
  if (type === "users") {
    return (
      <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 00-3-3.87" />
        <path d="M16 3.13a4 4 0 010 7.75" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
};

const ProblemSection = () => (
  <section className="problem-section">
    <div className="problem-inner">
      <div className="reveal-left">
        <span className="section-eyebrow">The real problem</span>
        <h2 className="section-h2">
          You&apos;re not losing to
          <br />
          bad products. You&apos;re losing
          <br />
          to <em>bad suppliers.</em>
        </h2>
        <p className="section-p">
          Most dropshipping platforms let anyone sell. No vetting. No enforcement. You discover the
          problems only after your customers do — and by then, the damage is done.
        </p>
        <div className="pain-list">
          {PAIN_ITEMS.map((item) => (
            <div className="pain-item" key={item.icon}>
              <div className="pain-icon">
                <PainIcon type={item.icon} />
              </div>
              <div className="pain-text">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="reveal-right">
        <div className="problem-visual">
          <div className="problem-img-wrap">
            <img src="/images/spp.jpg" alt="Supplier problem" className="problem-img" />
          </div>
          <div className="problem-stat-card">
            <div className="psc-num">81%</div>
            <div className="psc-label">of negative reviews mention shipping issues</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ProblemSection;
